export const FETCH_CLIENT_PASSPORT_BOOKINGS = 'fetchClientPassportBookings'
export const FETCHED_CLIENT_PASSPORT_BOOKINGS = 'fetchedClientPassportBookings'
